// import React, { useEffect, useMemo, useState } from "react";
// import {
//   BackButton,
//   CancelButton,
//   SubmitButton,
// } from "../../../../Components/Utils/Buttons";
// import { Link, useParams } from "react-router-dom";
// import Dashboard from "../../../../Components/Icons/Dasboard";
// import { useFormik } from "formik";
// import useAddFormData from "../../../../Components/Hooks/useAddFormData";
// import * as yup from "yup";
// import {
//   NuDate,
//   NuInput,
//   NuMobileNumber,
//   NuSelect,
//   NuTextArea,
// } from "../../../../Components/Utils/Input";
// import FormikSelectTwo from "../../../../Components/Utils/Select";
// import axiosInstance from "../../../../Services/axiosCommon";
// import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
// import UseDropDown from "../../../../Components/Hooks/useDropDown";
// import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
// import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
// import { useToast } from "../../../../Components/Others/ToastServices";
// import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";

import { useParams } from "react-router-dom";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import UseDropDown from "../../../../../../Components/Hooks/useDropDown";
import { useEffect, useMemo, useState } from "react";
import { useFormik } from "formik";
import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
import { BackButton, CancelButton, SubmitButton } from "../../../../../../Components/Utils/Buttons";
import FormikSelectTwo, { SelectProductWithError } from "../../../../../../Components/Utils/Select";
import { NuDate, NuInput, NuInputWithError, NuTextArea } from "../../../../../../Components/Utils/Input";
import DropDownAddMetaData, { DropDownAddUnitWithError } from "../../../../../../Components/Utils/selectAddMetaData";
import Attachement from "../../../../../../Components/Utils/CustomAttrachmentupload";
import * as yup from "yup";
import axiosInstance from "../../../../../../Services/axiosCommon";
import { useToast } from "../../../../../../Components/Others/ToastServices";
import useAddFormData from "../../../../../../Components/Hooks/useAddFormData";
import UseProductDropDownNew from "../../../../../../Components/Hooks/useProductSearch";
import EditIcon from "../../../../../../Components/Icons/Edit";
import { Select } from "antd";
import DeleteIcon from "../../../../../../Components/Icons/Delete";
import DropDownAdd from "../../../../../../Components/Utils/selectAdd";
import DropDownAddSubCategory from "../../../../../../Components/Utils/selectAddSubCategory";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";








const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];
function CreateInvoiceProjectOutgoing() {
  // const [loading, setLoading] = useState(false);
  const {officeId,projecTId} =useParams();
  const {value:category ,getData:refcategory} = useFetchMataData(`/dropdown/dropdown-details/`,'category_invoicesIncoming')

  const currentDate = new Date().toISOString().split('T')[0];
  const {value:Tax ,getData:refTax} = useFetchMataData(`/dropdown/dropdown-details/`,'Tax_invoicesIncoming')
  const {value:ModeOfPayment ,getData:refModeOfPayment} = useFetchMataData(`/dropdown/dropdown-details/`,'ModeOfPayment_invoicesIncoming')
  const {value:Division ,getData:refDivision} = useFetchMataData(`/dropdown/dropdown-details/`,'Division_invoicesIncoming')
  //  const { data: PR } = UseDropDown('/PR/drop-down');
   const { data: user } = UseDropDown('/user/drop-down');

  // const { data: CO } = UseDropDown('/customer-orders/drop-down');
  // const { data: SO } = UseDropDown('/sales-order/drop-down');
  const toast = useToast();
  const [search, setSearch] = useState("");

   const [image, setImage] = useState([]);
   // const [division, setDivision] = useState([]);
  const [customerName, setCusName] = useState(null);
  const [customerEmail, setCusEmail] = useState(null);
  const { Oncancel, addFormData, contextHolder, isLoading } = useAddFormData();
  const { data: customer } = UseDropDown("/customers/drop-down");
  const [soTotal,setSoTotal] = useState([]);
  const [sortedProList,setSortedProList] =  useState([]);
  const [oldData, setOldData] = useState([])
  const { data: Item, setData } = UseProductDropDownNew(
    `/items/new-drop-down/${officeId}/branch`,
    search
  ); 
  const [items, setItems] = useState([]);
  const [createNew, setCreateNew] = useState({
    date: currentDate || "",
    amount: "",
    tax: "",
    totalAmount: "",
    modeOfPayment: "",
    paymentDueDate: currentDate || "",
    receivedOn: currentDate || "",
    comments: "",
    customerId: "",
    // "status": "Pendding",
    division: "",
    ref: "",
    coId: "",
    taxAmount:"",
    bankCharges:"",
    costCode:"",
    description:"",
    category:"",
    debitTo:"",
    receivedAmount:"",
    balanceAmount:"",
    paymentReleasedOn:"",
    paymentReceivedOn:"",
    projectId:projecTId
  });
  const [newItemData, setNewItemData] = useState({
      productId:"",
      product_unit: "",
      quantity:"",
   sno:""
   
    });
    
    const { value: product_unit, getData: refUnit } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Unit_item"
    );
  const [selectedFile, setSelectedFile] = useState(null);
const [isEditQua, setIsEditQua] = useState(false);
const [isEditUnit, setIsEditUnit] = useState(false);
const [error, setError] = useState("");
const [productError, setProductError] = useState("");
const [unitError, setUnitError] = useState("");
const [quantityError, setQuantityError] = useState("");
const handleAdd = () => {
  let hasError = false;

  if (!formik.values.productId) {
    setProductError("Product is required");
    hasError = true;
  } else {
    setProductError("");
  }

  if (!formik.values.product_unit) {
    setUnitError("Unit is required");
    hasError = true;
  } else {
    setUnitError("");
  }

  if (!formik.values.quantity) {
    setQuantityError("Quantity is required");
    hasError = true;
  } else {
    setQuantityError("");
  }

  if (hasError) return;

  if (formik.values.productId && formik.values.quantity) {
    const selectedProduct = Item.find(
      (i) => i.value === formik.values.productId
    );
    const newItem = {
      productId: formik.values.productId,
      productName: sortedProList.find((i) => i.value === formik.values.productId),
      quantity: formik.values.quantity,
      // unit:selectedProduct.unit
      product_unit: formik.values.product_unit,
    };
    setItems([...items, newItem]);

    setNewItemData({
      productId: "",
      quantity: "",
      product_unit: "",
      // unit:""
    });
    let updatedItems = Item.filter(
      (it) => it.value !== formik.values.productId
    );
    setData(updatedItems);
    formik.values.productId = "";
    formik.values.quantity = "";
    formik.values.product_unit = "";
    setError("");
  }
};
  useEffect(()=>{
    if(Item){
      const union = Array.from(
        new Map([...Item, ...oldData].map((item) => [item.value, item])).values()
      );
      let data = union.sort((a, b) => a.label.localeCompare(b.label))
      setSortedProList(data)
    }    
  },[Item])
  

  

  const handleQuantityChange = (e, index) => {
    const updatedQuantity = e.target.value;

    // Update the specific item's quantity
    const updatedItems = items.map((item, idx) => {
      if (idx === index) {
        return { ...item, quantity: updatedQuantity };
      }
      return item;
    });

    setItems(updatedItems); // Update the state with new quantity
  };

  const handleProductUnitChange = (value, index) => {
    const updatedItems = items.map((item, idx) => {
      if (idx === index) {
        return { ...item, product_unit: value?.value };
      }
      return item;
    });
    setItems(updatedItems);
  };

  const handleDeleteItem = (indexToDelete) => {
    const updatedItems = items.filter((_, index) => index !== indexToDelete);
    let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
    setItems(updatedItems);
    let tempDd = ddUpdatedItem.productName;
    setData([...Item, tempDd]);
    // localStorage.setItem("items", JSON.stringify(updatedItems));
  };

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.map((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          // placement: "bottomRight",
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.map((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        console.log("fname", fileName);
        let fileExtention = fileName.split(".").reverse()[0];
        if (filetype?.includes(fileExtention)) {
          tempArr.push(fileName);
        } else {
          let x = URL.createObjectURL(item);
          tempArr.push(x);
        }
      }
    });
    console.log(tempArr, "temp");
    setImage(tempArr);
  }

  const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      // console.log('fname',fileName);
      // let fileExtention =  fileName.split(".").reverse()[0]
      // if(filetype?.includes(fileExtention)){
      tempArr.push(fileName);
      // }else{
      //   let x = URL.createObjectURL(item)
      //   tempArr.push(x)
      // }
    });
    setImage(tempArr);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // prId: yup.string().required('YPR is required!'),
      amount: yup.string().required('amount is required!'),


      // coId: yup.string().required('Sales Order is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      if (items.length === 0) {
        setError("Product table is empty");
        // setLoading(false)
  
        return;
      }
      // setLoading(true); 
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        products:items,
       
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      addFormData("/invoices-outgoing/new-invoice", formData, resetForm);
      // setLoading(false)
    },
  });

  const handlePopSubmit = async (e) => {
    e.preventDefault();
let pName= formik.values.productName
    const formData = new FormData();
    formData.append(
      "json_data",
      JSON.stringify({
        productName: formik.values.productName,
        unit: formik.values.unit,
        category: formik.values.category,
        subCategory: formik.values.subCategory,
        branchId: officeId,

      })
    );

    try {
      const response = await axiosInstance.post("/items/new-item", formData);
      const createdProduct = response.data?.data;
console.log(pName,"data");

      setData((prevProducts) => [
        {
          label: pName,
          value: createdProduct.id,
          unit: createdProduct.unit,
        }, // Add the new product at the start
        ...prevProducts,
      ]);

      resetForm();
    } catch (error) {
      console.error("Error creating new product:", error);
    }
  };
  const {
    category: itemsCategory,
    subCategory: itemsSubCategory,
    getCategory,
    fetchSubCategory,
  } = UseCatSubCatDropDown(
    "/category/ItemCategory",
    "ItemCategory",
    formik?.values?.category
  );

  const resetForm = () => {
    formik.values.productName = "";
    formik.values.unit = "";
    formik.values.category = "";
    formik.values.subCategory = "";
    setShowPop(false);
  };

  useMemo(() => {
    if (formik.values.tax != 0 || formik.values.tax != "") {
      let finalAmount = (formik.values.amount / 100) * formik.values.tax;
      formik.values.totalAmount = formik.values.amount + finalAmount;
    } else {
      formik.values.totalAmount = formik.values.amount;
    }
  }, [formik.values.amount, formik.values.tax]);

  const [Colist, setColist] = useState([]);
  // console.log("bnmbnm",Colist);

const [showPop, setShowPop] = useState(false);

  const togglePop = () => {
    setShowPop(!showPop);
  };
  const getPo = (coId) => {
    if (coId !== "") {
      axiosInstance
        .get(`/sales-order/${coId}`)
        .then(res => {
          console.log("nbnb",res?.data?.data?.products);
          let data = res?.data?.data?.products;
          let name = res.data?.data?.customerName;
          let email = res.data?.data?.customerEmail;
          let total = res?.data?.data?.subTotal.toFixed(2)
          setColist(data);
          name && setCusName(name);
          email && setCusEmail(email);
          total && formik.setFieldValue('amount',total)
          formik.setFieldValue('customerId',res.data?.data?.customerId)
          formik.setFieldValue('totalAmount',total)
        })
        .catch(err => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    if (formik.values.coId) {
      getPo(formik.values.coId);
    }
  }, [formik.values.coId]);

  useEffect(() => {
    const amount = parseFloat(formik.values.amount || 0);
    const tax = parseFloat(formik.values.tax || 0);
    
    const taxAmount = ((amount)* tax/100);  
    
    formik.setFieldValue("taxAmount", taxAmount.toFixed(2));
    formik.setFieldValue("totalAmount", (amount + taxAmount).toFixed(2));
  }, [formik.values.amount, formik.values.tax]);

   useEffect(() => {
      const totalAmount = parseFloat(formik.values.totalAmount || 0);
      const receivedAmount = parseFloat(formik.values.receivedAmount || 0);
      
      // const taxAmount = ((amount)* tax/100);  
      
      // formik.setFieldValue("taxAmount", taxAmount.toFixed(2));
      formik.setFieldValue("balanceAmount", (totalAmount + receivedAmount).toFixed(2));
    }, [formik.values.totalAmount, formik.values.receivedAmount]);
  

  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-end ">
        {/* <Breadcrumb
          items={[
            {
              name: "Invoice-Outgoing",
              link: `/project/sales/invoice_outgoing/${officeId}/${projecTId}`,
            },
            {
              name: "Create",
            },
          ]}
        /> */}
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
      <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
          <div className=" w-full h-full py-4 px-3 flex justify-start content-start flex-wrap  overflow-y-auto">
          
           <NuInput
                          label="Description"
                          type="text"
                          formik={formik}
                          placeholder="Description"
                          name="description"
                          width="w-full md:w-1/2 lg:w-2/3"
                        />
                        <NuInput
                        type="text"
                        label="Cost Code "
                        placeholder="Cost Code"
                        formik={formik}
                        name="costCode"
                        width="w-full md:w-1/2 lg:w-1/3"
                        // isRequired={true}
                      />
          {/* <FormikSelectTwo
                type="text"
                label="PR"
                placeholder="PR "
                Options={PR}
                formik={formik}
                name="prId"
                width="w-full md:w-1/2 lg:w-1/3"
                isRequired={true}
                // disabled={true}
              /> */}
          {/* <FormikSelectTwo
              type="text"
              label="Sales Order"
              placeholder="Sales Order"
              Options={SO}
              formik={formik}
              name="coId"
              width="w-full md:w-1/2 lg:w-1/3"
              isRequired={true}
            /> */}

            <FormikSelectTwo
              type="text"
              label="Client"
              placeholder="Client"
              Options={customer}
              formik={formik}
              name="customerId"
              width="w-full md:w-1/2 lg:w-1/3"
              FixPosition={false}
              PortalTarget={false}
            />
            {/* <NuInput
              type="number"
              label="Invoice Reference"
              placeholder="Invoice Reference"
              formik={formik}
              name="ref"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuDate
              label="Invoice Date"
              placeholder="Invoice Date"
              formik={formik}
              name="date"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
 {/* <NuDate
              label="Received Date"
              placeholder=" Received Date"
              formik={formik}
              name="date"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuInput
                          type="number"
                          label="Bank Charges"
                          placeholder="Bank Charges"
                          formik={formik}
                          name="bankCharges"
                          width="w-full md:w-1/2 lg:w-1/3"
                        /> */}

<FormikSelectTwo
              type="text"
              label="Debit To"
              placeholder="Debit To"
              Options={user}
              formik={formik}
              name="debitTo"
              width="w-full md:w-1/2 lg:w-1/3"
              // isRequired={true}
              FixPosition={false}
              PortalTarget={false}
            />
            <NuInput
              // value={soTotal}
              type="number"
              label="Amount"
              placeholder=" Amount"
              formik={formik}
              name="amount"
              width="w-full md:w-1/2 lg:w-1/3"
            />
             <DropDownAddMetaData
                label="Tax (%)"
                placeholder="Choose"
                Options={Tax}
                formik={formik}
                name="tax"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refTax}
                displayProperty={"Tax (%)"}
                propertyName={"Tax_invoicesIncoming"}
              />
        <NuInput
  type="text"
  label="Tax Amount"
  placeholder="Tax Amount"
  formik={formik}
  name="taxAmount"
  width="w-full md:w-1/2 lg:w-1/3"
  disabled={true}
/>
            <NuInput
              type="number"
              label="Total Amount"
              placeholder="Total Amount"
              formik={formik}
              name="totalAmount"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            />

<NuInput
              type="number"
              label="Received Amount"
              placeholder="Received Amount"
              formik={formik}
              name="receivedAmount"
              width="w-full md:w-1/2 lg:w-1/3"
              // disabled={true}
            />
            <NuInput
              type="number"
              label="Balance Amount"
              placeholder="Balance Amount"
              formik={formik}
              name="balanceAmount"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            />
           
            <NuDate
              label="Payment DueDate"
              placeholder="Payment Due Date"
              formik={formik}
              name="paymentDueDate"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {formik.values.receivedAmount && (
                        <NuDate
                          label="Received On"
                          placeholder="Received On"
                          formik={formik}
                          name="receivedOn"
                          width="w-full md:w-1/2 lg:w-1/3"
                        />)}
            <NuDate
              label="Payment Received On"
              placeholder="Payment Received On"
              formik={formik}
              name="paymentReceivedOn"
              width="w-full md:w-1/2 lg:w-1/3"
            />
             <DropDownAddMetaData
                label="Mode Of Payment"
                placeholder="Choose"
                Options={ModeOfPayment}
                formik={formik}
                name="modeOfPayment"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refModeOfPayment}
                displayProperty={"Mode Of Payment"}
                propertyName={"ModeOfPayment_invoicesIncoming"}
              />

<DropDownAddMetaData
              label="Category"
              placeholder="Choose"
              Options={category}
              formik={formik}
              name="category"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refcategory}
              displayProperty={"category"}
              propertyName={"category_invoicesIncoming"}
            />
            
 {/* <DropDownAddMetaData
                label="Division"
                placeholder="Choose"
                Options={Division}
                formik={formik}
                name="division"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refDivision}
                displayProperty={"Division"}
                propertyName={"Division_invoices"}
              /> */}
            
           
            <NuTextArea
              label="Comments"
              placeholder="Comments"
              formik={formik}
              name="comments"
              new_width="w-full md:w-2/3"

              width="w-full md:w-1/2 lg:w-1/3"
            />
             <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                  Attachement :
                </p>
              </div>
              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              />
            
            <div className="w-full flex px-6">
            {formik.values.coId && (
              <>
                <div className="w-full md:w-1/2 lg:w-1/3 flex px-6">
                  <p className="w-1/2 py-3 text-xs font-medium text-[#111537]">
                    Customer Name
                  </p>
                  <p className="w-1/2 py-3 pl-5  text-xs text-[#606279]">
                    {customerName}
                  </p>
                </div>
                <div className="w-full md:w-1/2 lg:w-1/3 flex px-6">
                  <p className="w-1/2 py-3 text-xs font-medium text-[#111537]">
                    Customer Email
                  </p>
                  <p className="w-1/2 py-3 pl-5  text-xs text-[#606279]">
                    {customerEmail}
                  </p>
                </div>
              </>
            )}
            </div>
            <div className="w-full h-0.5 opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div>
             <div className="w-full mx-auto  bg-white rounded-md pb-4 mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap  mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                  Products :
                </p>
              </div>
              <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                <SelectProductWithError
                  type="text"
                  label="Product "
                  placeholder="Product "
                  Options={sortedProList}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                  ErrMessage={productError}
                  px="0"
                  handleClick={togglePop}
                  setSearch={setSearch}
                  FixPosition={false}
                  PortalTarget={false}
                />
                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={product_unit}
                  formik={formik}
                  name="product_unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                  ErrMessage={unitError}
                  FixPosition={false}
                  PortalTarget={false}
                />
                {/* <button
                  onClick={togglePop}
                  type="button"
                  className=" p-3 py-2 mt-9  text-center h-8 cursor-pointer bg-[#048178] border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                  >
                  
                  +
                </button> */}
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full md:w-1/2 lg:w-1/4 "
                  ErrMessage={quantityError}
                />
                <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-8 m-1 text-center h-8 cursor-pointer bg-textColor-main border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
              </div>
              <div className="w-full bg-white overflow-y-scroll mt-5">
                {error && (
                  <p className="text-xs font-semibold text-red-500">{error}</p>
                )}
                <div className="w-full py-3  bg-[#048178] flex justify-between rounded-lg px-6">
                  <p className="w-[5%]  text-left  text-white text-xs font-medium">
                    S.No{" "}
                  </p>

                  <p className=" w-[55%] text-left text-white text-xs font-medium">
                    Product
                  </p>
                  <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Unit
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditUnit((prv) => !prv);
                      }}
                    >
                      {isEditUnit === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditUnit === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                  <p className=" w-[20%] text-center  text-white text-xs font-medium flex justify-center">
                    Quantity
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditQua((prv) => !prv);
                      }}
                    >
                      {isEditQua === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditQua === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>

                  <p className=" w-[5%] text-right text-white text-xs font-medium">
                    Action
                  </p>
                </div>
                {items?.length > 0 ? (
                  <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                    {items.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6  odd:bg-white even:bg-slate-50"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1}
                          </p>
                          <p className=" w-[55%] text-left  text-xs font-medium text-[#111537] py-2.5">
                            {List?.productName?.label||""}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            {/* {List?.unit} */}
                            <Select
                              value={
                                product_unit.find(
                                  (item) => item?.value == List.product_unit
                                ) || List.product_unit
                              }
                              options={isEditUnit ? product_unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChange(value, index)
                              }
                              disabled={!isEditUnit}
                            />
                          </p>

                          <p className=" w-[20%] text-center   text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className=" w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity}
                              disabled={!isEditQua}
                              onChange={(e) => handleQuantityChange(e, index)}
                            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDeleteItem(index)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteIcon color="red" height={4} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="w-full text-center text-[#93949f]">
                    No Items here
                  </div>
                )}
              </div>
              <div className="w-full hidden md:block mx-auto my-4 mt-8 pb-2">
                <div className="md:flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
             {/* <div className="w-full h-0.5 opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div>
            <div className="w-full bg-white overflow-y-scroll mt-5">
              <div className="w-full py-3 bg-[#048178] flex justify-between rounded-lg px-2">
              <p className="w-[5%]  text-left  text-white text-xs font-medium">S.N. </p>

                <p className="w-[50%] text-left text-white text-xs font-medium">Product</p>
                <p className="w-[10%] text-center text-white text-xs font-medium">Unit</p>
                <p className="w-[15%] text-center text-white text-xs font-medium"> Quantity</p>
                <p className="w-[15%] text-center text-white text-xs font-medium">Price</p>
                <p className="w-[15%] text-center text-white text-xs font-medium">Total</p>
              
              </div>
              {Colist?.length>0?
              <div className="h-[calc(100vh-300px)] overflow-y-scroll">

              {Colist.map((List, index) => (
                <div key={index} className="w-full py-2 flex justify-between px-2 odd:bg-white even:bg-slate-50">
                  <p className="w-[5%]  text-left  text-[#606279] text-xs font-light py-1">
                                    {index + 1}
                                </p>
                  <p className="w-[50%] text-left text-[#606279] text-xs font-light">{List?.product_name}</p>
                  <p className="w-[10%] text-center text-[#606279] text-xs font-light">{List?.unit}</p>
                  <p className="w-[15%] text-center text-[#606279] text-xs font-light">{List?.quantity}</p>
                  <p className="w-[15%] text-center text-[#606279] text-xs font-light">{List?.price}</p>
                  <p className=" w-[15%] text-center text-[#606279] text-xs font-light">
                  {(List.price * List.quantity ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                  
                  </p>
                </div>
              ))}
            </div>:<div className="w-full text-center text-[#93949f]">No Items here</div>}

            </div> */}

            {/* <div className="w-full hidden md:block mx-auto my-4 mt-8 ">
              <div className="md:flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    Oncancel(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading}/>
              </div>
            </div> */}
          </div>
        </div>
      </form>
      {showPop && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-medium text-[14px]">Add Product</h2>
            <form onSubmit={handlePopSubmit}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  label="Product Name"
                  type="text"
                  formik={formik}
                  placeholder="Product Name"
                  name="productName"
                  width="w-full"
                  isRequired={true}
                />

                <DropDownAddMetaData
                  label="Unit"
                  placeholder="Choose"
                  Options={product_unit}
                  formik={formik}
                  name="unit"
                  width="w-full md:w-1/2 lg:w-1/2"
                  getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                  isRequired={true}
                  FixPosition={true}
                  PortalTarget={false}
                  
                />
                <DropDownAdd
                  type="text"
                  label="Category"
                  placeholder="Category"
                  Options={itemsCategory}
                  formik={formik}
                  name="category"
                  width="w-full md:w-1/2 lg:w-1/2"
                  getFunc={getCategory}
                  categoryName={"ItemCategory"}
                  displayProperty={"Add Category"}
                  isRequired={true}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <DropDownAddSubCategory
                  type="text"
                  label="Sub-Category"
                  placeholder="Sub-Category"
                  Options={itemsSubCategory}
                  formik={formik}
                  name="subCategory"
                  width="w-full md:w-1/2 lg:w-1/2"
                  getFunc={fetchSubCategory}
                  category={formik?.values?.category}
                  module={"ItemCategory"}
                  displayProperty={"Add Sub-Category"}
                  FixPosition={true}
                  PortalTarget={false}
                />

              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePop}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                  rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreateInvoiceProjectOutgoing;
